module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "contentlist"
    }
  }, _vm._l((_vm.newsdata), function(item, index) {
    return _c('el-row', {
      key: item.id,
      attrs: {
        "type": "flex",
        "justify": "center"
      }
    }, [_c('el-col', {
      staticClass: "el-item",
      attrs: {
        "xs": 24,
        "sm": 24,
        "md": 22,
        "lg": 14
      }
    }, [_c('div', {
      staticClass: "box shadow"
    }, [(_vm.labelname === '录音已上传' && item.mediaurl) ? _c('div', {
      staticClass: "box-record-label"
    }, [_c('span', {
      staticClass: "box-label-text"
    }, [_vm._v(_vm._s(_vm.labelname))])]) : (_vm.labelname === '已修改' && item.tip) ? _c('div', {
      staticClass: "box-audit-label"
    }, [_c('span', {
      staticClass: "box-label-text"
    }, [_vm._v(_vm._s(_vm.labelname))])]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "news-box"
    }, [_c('router-link', {
      attrs: {
        "to": {
          path: _vm.urladdr,
          query: {
            id: item.id,
            index: index
          }
        }
      }
    }, [_c('div', {
      staticClass: "box-header fs-catego"
    }, [_c('span', {
      staticClass: "new-type"
    }, [_vm._v(_vm._s(item.category))]), _vm._v(" "), _c('span', {
      staticClass: "hot-level"
    }, [_vm._v(_vm._s(item.hotindex))])]), _vm._v(" "), _c('div', {
      staticClass: "box-title"
    }, [_c('h1', {
      staticClass: "fs-title"
    }, [_vm._v(_vm._s(item.title))])]), _vm._v(" "), _c('div', {
      staticClass: "box-date fs-label"
    }, [_c('span', [_vm._v(_vm._s(item.date))]), _vm._v(" "), (item.editorname) ? _c('span', [_vm._v("编:" + _vm._s(item.editorname))]) : _vm._e(), _vm._v(" "), (item.hostname) ? _c('span', [_vm._v(" 播:" + _vm._s(item.hostname))]) : (item.host) ? _c('span', [_vm._v(" 播:" + _vm._s(item.host))]) : _vm._e(), _vm._v(" "), (item.verifiername) ? _c('span', [_vm._v(" 审:" + _vm._s(item.verifiername))]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "box-content"
    }, [(item.cover) ? _c('img', {
      staticClass: "box-image",
      attrs: {
        "src": item.cover
      }
    }) : _vm._e(), _vm._v(" "), _c('p', {
      staticClass: "box-text fs-text"
    }, [_vm._v(_vm._s(item.content))])]), _vm._v(" "), _c('div', {
      staticClass: "box-foot"
    }, [_c('div', {
      staticClass: "host-name"
    }, [(item.category) ? _c('span', {
      staticClass: "fs-label"
    }, [_c('b', [_vm._v(_vm._s(item.state))])]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "foot-label fs-label"
    }, _vm._l((item.labels), function(lable, index) {
      return _c('span', {
        key: index
      }, [(index === 0) ? _c('span', [_vm._v(_vm._s(lable))]) : _c('span', [_vm._v(" / " + _vm._s(lable))])])
    }))]), _vm._v(" "), _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.tipshow && item.tip),
        expression: "tipshow && item.tip"
      }],
      staticClass: "box-tag"
    }, [_c('img', {
      attrs: {
        "src": require("../../static/img/ibroadcast/bohui.png")
      }
    })])])], 1)])])], 1)
  }))
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-304845cc"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/contentlist.vue
// module id = 290
// module chunks = 0 7